module.exports = __webpack_public_path__ + "img/guide-img3.fe79b4f9.jpg";